import { Table } from "@tanstack/react-table";
import DataTablePagination from "./pagination";

export interface DataTableFooterProps<TData> {
  type: "server" | "client" | "none";
  table: Table<TData>;
  rowsCount?: number;
  dividerColor?: string;
  paperBackground?: string;
  pageSizeOptions?: number[];
  /** Rendered right after the "Showing: … results" cluster. */
  startContent?: React.ReactNode;
}

export default function DataTableFooter<TData>({
  type,
  table,
  rowsCount = 0,
  paperBackground = "#FFFFFF",
  pageSizeOptions = [10, 25, 50, 100],
  startContent,
}: DataTableFooterProps<TData>) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "6px 12px",
        flexShrink: 0,
        backgroundColor: paperBackground,
      }}
    >
      <DataTablePagination
        startContent={startContent}
        rowsCount={rowsCount}
        calculatedPageCount={
          type === "server"
            ? Math.ceil(
                (table.getRowCount() || 0) /
                  table.getState().pagination.pageSize
              )
            : table.getPageCount()
        }
        pagination={table.getState().pagination}
        setPagination={table.setPagination}
        pageSizeOptions={pageSizeOptions}
      />
    </div>
  );
}
